var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("DatePicker", {
        attrs: {
          value: "",
          inline: true,
          "disabled-dates": { customPredictor: _vm.predictDisabledDates },
          highlighted: { customPredictor: _vm.predictHighlightedDates },
        },
        on: { selected: _vm.dateSelected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }